/**
 * Datum und Verantwortlicher in einer Zeile der Startseite – mit dezentem Icon davor (abschaltbar,
 * wo feste Spalten die Angabe schon einordnen) und direkt in der Zeile änderbar. Genutzt von den Terminen und der aufgeklappten Projektzeile, damit
 * beide gleich aussehen und sich gleich bedienen.
 *
 * Was geändert werden darf und wie gespeichert wird, entscheidet der Aufrufer.
 */
import React from "react";
import {
  EventOutlined as EventIcon,
  PersonOutlineOutlined as PersonIcon,
} from "@mui/icons-material";
import { format, parseISO } from "date-fns";
import DetailCell, { detailIconSx } from "../../../common/display/DetailCell";
import InlineDatePicker from "../../../common/inputs/InlineDatePicker";
import InlineUserPicker, {
  InlineUserOption,
} from "../../../common/inputs/InlineUserPicker";

/** Datum mit Kalender-Icon, immer zweistellig, damit Daten untereinander fluchten */
export const EditableDate: React.FC<{
  /** ISO-Datum; ohne steht ein Strich */
  value?: string | null;
  editable: boolean;
  ariaLabel: string;
  /** Was für ein Datum es ist („Geplante Genehmigung“) – steht über dem Kalender */
  label?: string;
  /** Ohne Icon, z. B. in den Terminen, wo das Datum immer ganz rechts steht */
  hideIcon?: boolean;
  onChange: (iso: string) => void;
}> = ({ value, hideIcon, ...picker }) => (
  <InlineDatePicker value={value} {...picker}>
    <DetailCell icon={hideIcon ? undefined : <EventIcon sx={detailIconSx} />}>
      {value ? format(parseISO(value), "dd.MM.yyyy") : "–"}
    </DetailCell>
  </InlineDatePicker>
);

/** Verantwortlicher mit Personen-Icon */
export const EditableUser: React.FC<{
  /** IAM-ID – markiert ihn in der Auswahl */
  userId?: string;
  name?: string;
  users: InlineUserOption[];
  editable: boolean;
  ariaLabel: string;
  /** Ohne Icon, z. B. in den Terminen, wo der Name immer vor dem Datum steht */
  hideIcon?: boolean;
  onChange: (userId: string) => void;
}> = ({ userId, name, hideIcon, ...picker }) => (
  <InlineUserPicker value={userId} {...picker}>
    <DetailCell icon={hideIcon ? undefined : <PersonIcon sx={detailIconSx} />}>
      {name || "–"}
    </DetailCell>
  </InlineUserPicker>
);
